import { InjectRepository } from "@nestjs/typeorm";
import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { NeedleReturnAfterProductionEntity } from "./needle-return-after-production.entity";

@Injectable()
export class NeedleReturnProductionRepository extends Repository<NeedleReturnAfterProductionEntity> {

    constructor(@InjectRepository(NeedleReturnAfterProductionEntity) private needleReturnRepo: Repository<NeedleReturnAfterProductionEntity>
    ) {
        super(needleReturnRepo.target, needleReturnRepo.manager, needleReturnRepo.queryRunner);
    }

    async getAllNeedleReturnProductionQuery(): Promise<any> {
        return await this.createQueryBuilder('srd')
          .select([
            'srd.id AS id',
            'so.job_no AS jobNo','return_status AS returnStatus',
            'srd.return_qty AS returnQty','nm.needle_model AS needleModel','pt.point_type AS needlePoint','ns.needle_sizes AS needleSize',
            'srd.return_to AS returnTo','m.machine_type AS machineType','m.machine AS machine',
            'srd.return_by AS returnBy',
            'srd.remaining_qty AS remainingQty',
            'so.stock_id AS stockId',
            'so.issued_quantity AS issuedQuantity',
            'srd.return_purpose AS returnPurpose',
           ' srd.no_of_pieces AS noOfPieces',
            'srd.date_of_return AS dateOfReturn'
          ])
          .leftJoin('stock_out', 'so', 'so.id = srd.job_id')
          .leftJoin('material_request', 'mr', 'mr.material_req_id = so.request_id')
          .leftJoin('machines', 'm', 'm.id = mr.machine_id')
          .leftJoin('needle_model', 'nm', 'm.id = mr.needle_model_id')
          .leftJoin('point_types', 'pt', 'pt.id = mr.needle_point_id')
          .leftJoin('needle_sizes', 'ns', 'ns.id = mr.needle_size_id')
          .getRawMany();
      }

      async getAllNeedleReturnReport(req:any): Promise<any> {
        
          let query = "select sty.style,so.module_no AS moduleNo,so.shift,srd.id AS id,so.job_no AS jobNo,return_status AS returnStatus,srd.return_qty AS returnQty,nm.needle_model AS needleModel,pt.point_type AS needlePoint,ns.needle_sizes AS needleSize,srd.return_to AS returnTo,m.machine_type AS machineType,m.machine AS machine,srd.return_by AS returnBy,srd.remaining_qty AS remainingQty,so.stock_id AS stockId,so.issued_quantity AS issuedQuantity,srd.return_purpose AS returnPurpose,srd.no_of_pieces AS noOfPieces,srd.date_of_return AS dateOfReturn from stock_return srd left join stock_out so on so.id = srd.job_id left join material_request mr on mr.material_req_id = so.request_id left join machines m on m.id = mr.machine_id left join needle_model nm on m.id = mr.needle_model_id left join point_types pt on pt.id = mr.needle_point_id left join needle_sizes ns on ns.id = mr.needle_size_id left join style sty on sty.id = so.style_id "
          if (req.fromDate && req.toDate) {
            query += ` WHERE DATE(srd.date_of_return) BETWEEN '${req.fromDate}' AND '${req.toDate}' `;
        }
        let data = await this.needleReturnRepo.query(query);
        if(data.length>0){
          return data
          
        }
        else{
          return []
        }
      }


      
      

}

